class CartSellingPlanSelect extends HTMLElement {
    constructor() {
      super()
      this.selling_plan_tab_one_time = this.querySelector("input.sellingplan_tab.one-time")
      this.cart = document.querySelector("cart-items") || document.querySelector("cart-drawer-items");
      this.selling_plan_select = this.querySelector(".selling_plan-select")
      this.selling_plan_select.addEventListener("change", this.changeCartSellingPlan.bind(this))
      this.selling_plan_tab_one_time.addEventListener("input", this.changeCartSellingPlan.bind(this));
      this.selectedSellingPlanValue = null;
      if(window.location.href.indexOf("/products") !== -1){
        console.log(`test: `);
        this.setHiddenInputValue()
      }
    }
    createAddArray() {
      let add_items = []
      
      let cart_items = this.cart.querySelectorAll(".cart-item")
      cart_items.forEach(item => {
        let variant_id = item.dataset.variantId
        if(!item.querySelector("special-product")){
        let quantity = item.querySelector('quantity-popover input[type="number"]').value
    
        let selling_plan_ids 
        let new_selling_plan_id = null
        
        if(item.dataset.sellingPlanIds  != undefined){
          selling_plan_ids= item.dataset.sellingPlanIds.split(",")
        }
  
        if (this.selectedSellingPlanValue != null && item.dataset.sellingPlanIds != undefined ) {
          new_selling_plan_id = selling_plan_ids[this.selectedSellingPlanValue]
          if (new_selling_plan_id == undefined) {
            new_selling_plan_id = null
          }
        }
  
        let add_item = {
          id: variant_id,
          quantity,
          selling_plan: new_selling_plan_id
        }
        add_items.push(add_item)
        }
        else if(item.querySelector("special-product")){
          if(item.querySelector("special-product input[type='checkbox'").checked){
            let add_item = {
              id: variant_id,
              quantity: 1
            }
            add_items.push(add_item)
          }
        }
        
      })
      add_items.reverse()
      let add_arrays = splitArray(add_items, 20)
      return add_arrays
    }
  
    changeCartSellingPlan(event) {
          if(event.target.closest(".sellingplan_tab")?.classList.contains("one-time")){
            this.selectedSellingPlanValue = null;
          }
          else{
            this.selectedSellingPlanValue = event.target.value
          }
          
          if(this.selectedSellingPlanValue != null){
            this.selectedSellingPlanValue = Number(this.selectedSellingPlanValue)
  
            const d = new Date();
            const cookieExpire = d.setTime(d.getTime() + (24 * 60 * 60 * 1000));
            console.log(event.target)
            document.cookie = `active_selling_plan=${event.target.value};${cookieExpire};`
          }
  
  
      // Change Hidden Input when on PDP 
      if(window.location.href.indexOf("/products") !== -1){
        console.log("TESTE12")
        this.setHiddenInputValue()
      }
  
  
  
      let addArrays = this.createAddArray()
      // console.log("add", addArrays)
      window.sessionStorage.setItem("add-selling-plan-arrays", JSON.stringify(addArrays))
  
  
      fetch(window.Shopify.routes.root + 'cart/clear.js')
      .then(response => {
        addArrays.forEach(array => {
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body:
              JSON.stringify({
                items:
                  array,
                  sections: this.cart.getSectionsToRender().map((section) => section.section),
                  sections_url: window.location.pathname
  
  
              })
          })
          .then(response => {
            // console.log(response)
            return response.text()
          })
              .then((state) => {
            const parsedState = JSON.parse(state);
    
    
            if (parsedState.errors) {
              this.displayErrors(line, parsedState.errors);
              this.container.classList.remove('cart-disabled');
              return;
            }
            this.cart.renderContents(parsedState);
            document.dispatchEvent(new CustomEvent('selling-plan::changed'))
          });
        })
      }
  
      )
    }
    // If on PDP change hidden input value
    setHiddenInputValue(){
      let selling_plan_input = document.querySelector("input[name='selling_plan']")
      if(this.querySelector(".sellingplan_tab.one-time:checked") && selling_plan_input != undefined){
        selling_plan_input.value = ""
      }
      else if(selling_plan_input != undefined){
        console.log(`selling_plan_input: `, selling_plan_input);
       selling_plan_input.value = document.querySelector(".selling_plan_ids")?.dataset.sellingPlanIds.split(",")[this.selling_plan_select.value]
      }      
    }
  }
  customElements.define("cart-selling-plan-select", CartSellingPlanSelect)
  
  function splitArray(array, chunkSize) {
    let result = [];
  
    for (let i = 0; i < array.length; i += chunkSize) {
      let chunk = array.slice(i, i + chunkSize);
      result.push(chunk);
    }
  
    return result;
  }
  
  
  class TabComponentSubscription extends HTMLElement {
    constructor() {
        super();
        this.addEventListener("change", (event) => {
            if (event.target.dataset.openTab) {
                const tabId = event.target.dataset.openTab;
                const oldTabs = document.querySelectorAll(".tab__content.active");

                oldTabs.forEach(ele => ele.classList.remove("active"));
                const tabElements = document.querySelectorAll(`#open-${tabId}`);
                tabElements.forEach(ele => ele.classList.add("active"));
            }
        });
    }
}

customElements.define("tab-component-subscription", TabComponentSubscription);